const Organizations = () =>
  import(
    /* webpackChunkName: "base-info-organization-organization" */ '@/pages/base-info/organization/organizations/index.vue'
  )
const CreateOrganizations = () =>
  import(
    /* webpackChunkName: "base-info-organization-organization" */ '@/pages/base-info/organization/organizations/create.vue'
  )
const EditOrganizations = () =>
  import(
    /* webpackChunkName: "base-info-organization-organization" */ '@/pages/base-info/organization/organizations/edit.vue'
  )

export default {
  path: 'organizations',
  meta: {
    label: 'organization',
    auth: 'organization'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrgOrganization',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Organizations
    },
    {
      name: 'BaseInfoCreateOrgOrganization',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateOrganizations
    },
    {
      name: 'BaseInfoEditOrgOrganization',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditOrganizations,
      props: true
    }
  ]
}
